// extracted by mini-css-extract-plugin
module.exports = {"vertical_line":"ContactInformationForm_vertical_line__ba1Oo","other_contact_div":"ContactInformationForm_other_contact_div__1OEFm"};